// Load assessment form first so it still runs if another partial throws.
require( './partials/start-your-free-assessment.js' );

function requireAll( r ) {
	r.keys()
		.filter( ( key ) => ! key.includes( 'start-your-free-assessment' ) )
		.forEach( r );
}

requireAll( require.context( './partials/', true, /\.js$/ ) );
